import { RANCHBOT_COUNTRIES_ABBR } from 'constants/index';
import { isFarmbot as isFarmbotDomain } from 'utils/is-x-bot';

export const supportsCibo = (enterpriseCountry?: string): boolean => {
  const isRanchbotCountry = enterpriseCountry && RANCHBOT_COUNTRIES_ABBR.includes(enterpriseCountry);
  const isFarmbot = !isRanchbotCountry && isFarmbotDomain();

  return isFarmbot;
};